class WLSBlogContent extends HTMLElement {
    constructor() {
        super();

        this.classes = {
            active: 'active',
            sticky: 'sticky',
            promoBar: 'ca-aud-033-banner-container',
            promoBarNew: 'wlsn-promo-bar',
            header: 'wls-header',
            headerNew: 'wlsn-header',
            progressBar: 'wls-blog-content__progress-bar',
            progressBarInner: 'wls-blog-content__progress-bar-inner',
            content: 'wls-blog-content__content',
            sidebar: 'wls-blog-content__sidebar',
            toc: 'wls-blog-content__toc',
            tocTitle: 'wls-blog-content__toc-title',
            tocList: 'wls-blog-content__toc-list',
            tocItem: 'wls-blog-content__toc-item',
            tocLink: 'wls-blog-content__toc-link',
            widget: 'wls-blog-content__widget',
            widgetSticky: 'wls-blog-content__widget-sticky'
        };

        this.elements = {
            promoBar: document.querySelector(`.${this.classes.promoBar}`) || document.querySelector(`.${this.classes.promoBarNew}`),
            header: document.querySelector(`.${this.classes.header}`) || document.querySelector(`.${this.classes.headerNew}`),
            progressBar: document.querySelector(`.${this.classes.progressBar}`),
            progressBarInner: document.querySelector(`.${this.classes.progressBarInner}`),
            content: this.querySelector(`.${this.classes.content}`),
            sidebar: this.querySelector(`.${this.classes.sidebar}`),
            widget: this.querySelector(`.${this.classes.widget}`),
            widgetSticky: this.querySelector(`.${this.classes.widgetSticky}`)
        };

        this.scrollHandler = this.handleScroll.bind(this);
        this.resizeHandler = this.handleResize.bind(this);
        this.tocClickHandler = this.handleTocClick.bind(this);
    }

    /**
     * Initialize when element is added to DOM
     */
    connectedCallback() {
        this.initStickyElements();
        this.initProgressBar();
        this.initTableOfContents();
        window.addEventListener('scroll', this.scrollHandler);
        window.addEventListener('resize', this.resizeHandler);
    }

    /**
     * Clean up when element is removed from DOM
     */
    disconnectedCallback() {
        window.removeEventListener('scroll', this.scrollHandler);
        window.removeEventListener('resize', this.resizeHandler);
    }

    /**
     * Initialize sticky elements
     */
    initStickyElements() {
        const promoBarSection = this.elements.promoBar?.closest('.shopify-section');
        const headerSection = this.elements.header?.closest('.shopify-section');

        // Handle promo bar if it exists
        if (promoBarSection) {
            promoBarSection.style.position = 'sticky';
            promoBarSection.style.top = '0';
            promoBarSection.style.zIndex = '10';
            promoBarSection.classList.add(this.classes.sticky);
        }

        // Handle header if it exists
        if (headerSection) {
            headerSection.style.position = 'sticky';
            headerSection.style.zIndex = '10';
            headerSection.classList.add(this.classes.sticky);
            
            // Set header top position based on promo bar presence
            if (this.elements.promoBar) {
                headerSection.style.top = `${this.elements.promoBar.offsetHeight}px`;
            } else {
                headerSection.style.top = '0';
            }
        }
    }

    /**
     * Initialize progress bar
     */
    initProgressBar() {
        if (!this.elements.progressBar || !this.elements.content) return;

        const promoBarHeight = this.elements.promoBar?.offsetHeight || 0;
        const headerHeight = this.elements.header?.offsetHeight || 0;
        this.elements.progressBar.style.top = `${promoBarHeight + headerHeight}px`;
    }

    /**
     * Initialize table of contents
     */
    initTableOfContents() {
        if (!this.elements.content || !this.elements.sidebar) return;

        const headings = this.elements.content.querySelectorAll('h2');
        if (headings.length === 0) return;

        // Create table of contents structure
        const toc = document.createElement('div');
        toc.className = this.classes.toc;

        const tocTitle = document.createElement('h3');
        tocTitle.className = this.classes.tocTitle;
        tocTitle.textContent = 'Table of Contents';
        toc.appendChild(tocTitle);

        const tocList = document.createElement('ol');
        tocList.className = this.classes.tocList;

        // Process each heading
        headings.forEach((heading, index) => {
            // Add ID to heading if it doesn't have one
            if (!heading.id) {
                heading.id = `heading-${index}`;
            }

            const listItem = document.createElement('li');
            listItem.className = this.classes.tocItem;

            const link = document.createElement('a');
            link.className = this.classes.tocLink;
            link.href = `#${heading.id}`;
            link.textContent = heading.textContent;
            link.addEventListener('click', this.tocClickHandler);

            listItem.appendChild(link);
            tocList.appendChild(listItem);
        });

        toc.appendChild(tocList);
        this.elements.sidebar.insertBefore(toc, this.elements.sidebar.firstChild);
    }

    /**
     * Handle table of contents link clicks
     * @param {Event} event
     */
    handleTocClick(event) {
        event.preventDefault();
        const targetId = event.target.getAttribute('href').substring(1);
        const targetHeading = document.getElementById(targetId);
        const toc = this.elements.sidebar?.querySelector(`.${this.classes.toc}`);
        
        if (!targetHeading || !toc) return;

        const promoBarHeight = this.elements.promoBar?.offsetHeight || 0;
        const headerHeight = this.elements.header?.offsetHeight || 0;
        const totalOffset = promoBarHeight + headerHeight;

        const targetPosition = targetHeading.getBoundingClientRect().top + window.pageYOffset - totalOffset - 20;
        
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });

        // Remove the immediate active class addition
        // The updateActiveTocItem method will handle this when the page scrolls
    }

    /**
     * Handle scroll event
     */
    handleScroll() {
        if (!this.elements.progressBarInner || !this.elements.content) return;

        const contentRect = this.elements.content.getBoundingClientRect();
        const contentTop = contentRect.top;
        const contentBottom = contentRect.bottom;
        const contentHeight = this.elements.content.offsetHeight;
        const windowHeight = window.innerHeight;
        const promoBarHeight = this.elements.promoBar?.offsetHeight || 0;
        const headerHeight = this.elements.header?.offsetHeight || 0;
        const totalOffset = promoBarHeight + headerHeight;

        // // Show/hide progress bar based on content visibility
        // if (contentBottom <= totalOffset || contentTop >= windowHeight) {
        //     this.elements.progressBar.style.opacity = '0';
        //     return;
        // } else {
        //     this.elements.progressBar.style.opacity = '1';
        // }

        if (contentTop > totalOffset) {
            this.elements.progressBarInner.style.width = '0%';
            return;
        }

        const scrolled = Math.abs(contentTop - totalOffset);
        const progress = Math.min((scrolled / (contentHeight - windowHeight + totalOffset)) * 100, 100);
        this.elements.progressBarInner.style.width = `${progress}%`;

        this.updateActiveTocItem();
        this.updateStickyWidget();
    }

    /**
     * Update sidebar position based on active TOC link
     * @param {HTMLElement} activeLink - The active TOC link
     * @param {HTMLElement} toc - The table of contents container
     */
    updateSidebarPosition(activeLink, toc) {
        if (!this.elements.sidebar) return;

        const promoBarHeight = this.elements.promoBar?.offsetHeight || 0;
        const headerHeight = this.elements.header?.offsetHeight || 0;
        const totalHeaderOffset = promoBarHeight + headerHeight;
        
        // Calculate available viewport height
        const viewportHeight = window.innerHeight;
        const availableHeight = viewportHeight - totalHeaderOffset - 50; // 50px buffer
        
        // Get sidebar height
        const sidebarHeight = this.elements.sidebar.offsetHeight;
        
        // Only proceed if sidebar is taller than available space
        if (sidebarHeight <= availableHeight) return;

        // Get the distance from the active link to the top of the TOC
        const tocRect = toc.getBoundingClientRect();
        const activeLinkRect = activeLink.getBoundingClientRect();
        const distanceFromTocTop = activeLinkRect.top - tocRect.top;

        // Calculate new top position for sidebar
        const totalOffset = totalHeaderOffset + 10; // 10px padding
        const newTopPosition = totalOffset - distanceFromTocTop;

        // Apply new position
        this.elements.sidebar.style.top = `${newTopPosition}px`;
    }

    /**
     * Update active TOC item
     */
    updateActiveTocItem() {
        const tocLinks = this.elements.sidebar?.querySelectorAll(`.${this.classes.tocLink}`);
        const toc = this.elements.sidebar?.querySelector(`.${this.classes.toc}`);
        if (!tocLinks?.length || !toc) return;

        const promoBarHeight = this.elements.promoBar?.offsetHeight || 0;
        const headerHeight = this.elements.header?.offsetHeight || 0;
        const totalOffset = promoBarHeight + headerHeight + 100; // Add some threshold

        let activeLink = null;

        for (const link of tocLinks) {
            const targetId = link.getAttribute('href').substring(1);
            const targetHeading = document.getElementById(targetId);
            
            if (targetHeading) {
                const headingTop = targetHeading.getBoundingClientRect().top;
                
                if (headingTop <= totalOffset) {
                    tocLinks.forEach(l => l.classList.remove(this.classes.active));
                    link.classList.add(this.classes.active);
                    activeLink = link;
                }
            }
        }

        // Only update position if we're on desktop and have an active link
        if (activeLink && window.innerWidth >= 1024) {
            this.updateSidebarPosition(activeLink, toc);
        }
    }

    /**
     * Update sticky widget visibility
     */
    updateStickyWidget() {
        if (!this.elements.widgetSticky || !this.elements.widget || !this.elements.content) return;
        
        // Only proceed if window width is less than 1024px
        if (window.innerWidth >= 1024) {
            this.elements.widgetSticky.classList.remove(this.classes.active);
            return;
        }

        const contentRect = this.elements.content.getBoundingClientRect();
        const widgetRect = this.elements.widget.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Calculate how much of the viewport is occupied by the content
        const contentVisibleHeight = Math.min(contentRect.bottom, windowHeight) - Math.max(contentRect.top, 0);
        const contentVisiblePercentage = (contentVisibleHeight / windowHeight) * 100;

        // Show sticky widget if:
        // 1. Content occupies at least 50% of viewport height
        // 2. Original widget is out of view (above the viewport)
        const isContentSufficient = contentVisiblePercentage >= 50;
        const isWidgetOutOfView = widgetRect.bottom <= 0;

        if (isContentSufficient && isWidgetOutOfView) {
            this.elements.widgetSticky.classList.add(this.classes.active);
        } else {
            this.elements.widgetSticky.classList.remove(this.classes.active);
        }
    }

    /**
     * Handle resize event
     */
    handleResize() {
        this.initStickyElements();
        this.initProgressBar();
        this.updateStickyWidget();
    }
}

if (!customElements.get('wls-blog-content')) {
    customElements.define('wls-blog-content', WLSBlogContent);
}